export { default as TrashcanIcon } from '~icons/lucide/trash-2';
